import React from 'react';

const marker = (
	<>
		<rect fill="#FF2D55" x="8" y="8" width="16" height="16" rx="8"/>
		<g strokeWidth="1" transform="translate(11.000000, 11.000000)">
			<polygon
				id="Fill-1" fill="#FEFEFE"
				points="4.7445 0.526157895 5.55555556e-05 2.72142105 5.55555556e-05 3.65247368 4.73894444 1.46826316 9.55005556 3.75773684 9.55005556 2.81563158"/>
			<polygon id="Fill-2" fill="#FEFEFE" points="0 8.91936842 9.55 8.91936842 9.55 8.01515789 0 8.01515789"/>
			<g id="Group-9" transform="translate(0.000000, 0.498316)">
				<path
					d="M1.07944444,5.80468421 C1.115,6.08626316 1.415,6.26678947 1.84666667,6.26678947 C2.24555556,6.26678947 2.52777778,6.08363158 2.52777778,5.82152632 C2.52777778,5.59994737 2.34444444,5.47257895 1.895,5.381 L1.41722222,5.28468421 C0.748888889,5.15257895 0.421111111,4.82257895 0.421111111,4.29310526 C0.421111111,3.63836842 0.977777778,3.20731579 1.82388889,3.20731579 C2.63166667,3.20731579 3.20333333,3.63573684 3.22611111,4.25468421 L2.50444444,4.25468421 C2.46888889,3.97994737 2.2,3.79731579 1.82888889,3.79731579 C1.445,3.79731579 1.19111111,3.96573684 1.19111111,4.23047368 C1.19111111,4.44468421 1.36666667,4.56731579 1.79611111,4.65363158 L2.23777778,4.74310526 C2.975,4.88994737 3.29222222,5.191 3.29222222,5.72994737 C3.29222222,6.43047368 2.72555556,6.85889474 1.80611111,6.85889474 C0.931666667,6.85889474 0.365555556,6.45205263 0.337777778,5.80468421 L1.07944444,5.80468421 Z"
					id="Fill-3" fill="#FEFEFE"/>
				<polygon id="Fill-5" fill="#FEFEFE"
								 points="4.27661111 6.76994737 4.27661111 3.29626316 5.04383333 3.29626316 5.04383333 4.84415789 5.08994444 4.84415789 6.44383333 3.29626316 7.29772222 3.29626316 5.96161111 4.81994737 7.39161111 6.76994737 6.47216667 6.76994737 5.40772222 5.31573684 5.04383333 5.72310526 5.04383333 6.76994737"/>
				<mask id="mask-12" fill="white">
					<use xlinkHref="#path-11"/>
				</mask>
				<g id="Clip-8"/>
				<polygon
					id="Fill-7" fill="#FEFEFE" mask="url(#mask-12)"
					points="8.22888889 6.77 8.99611111 6.77 8.99611111 3.29631579 8.22888889 3.29631579"/>
			</g>
		</g>
	</>
);

const SkiSchoolMarkers = () => (
	<>
		<path
			d="M1437,958.229542 L1455.16205,958.09668 C1462.71585,958.041421 1469.13219,963.611974 1470.13817,971.098683 L1471.46299,980.958191 L1471.46299,980.958191"
			stroke="#212121"/>
		<circle stroke="#212121" fill="#FFFFFF" cx="1471.44754" cy="980.958191" r="2"/>

		<g id="skischoolMarkers" transform="translate(1081.000000, 343.000000)">
			<g id="ic-skischool" transform="translate(0.000000, 741.000000)">{marker}</g>
			{/*<g id="ic-skischool" transform="translate(750.000000, 0.000000)">{marker}</g>*/}
			{/*<g id="ic-skischool" transform="translate(226.000000, 535.000000)">{marker}</g>*/}
			<g id="ic-skischool" transform="translate(334.000000, 599.000000)">{marker}</g>
			<g id="ic-skischool" transform="translate(428.000000, 717.000000)">{marker}</g>
			{/*<g id="ic-skischool" transform="translate(1015.000000, 567.000000)">{marker}</g>*/}
			{/*<g id="ic-skischool" transform="translate(1097.000000, 527.000000)">{marker}</g>*/}
			{/*<g id="ic-skischool" transform="translate(34.000000, 586.000000)">{marker}</g>*/}
			<g id="ic-skischool" transform="translate(332.000000, 503.000000)">{marker}</g>
			<g id="ic-skischool" transform="translate(571.000000, 572.000000)">{marker}</g>
			<g id="ic-skischool" transform="translate(441.000000, 640.000000)">{marker}</g>
		</g>
	</>
);

export default SkiSchoolMarkers;
